import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum CountryCodes {
  Afghanistan = 'AF',
  AlandIslands = 'AX',
  Albania = 'AL',
  Algeria = 'DZ',
  AmericanSamoa = 'AS',
  Andorra = 'AD',
  Angola = 'AO',
  Anguilla = 'AI',
  Antarctica = 'AQ',
  AntiguaAndBarbuda = 'AG',
  Argentina = 'AR',
  Armenia = 'AM',
  Aruba = 'AW',
  Australia = 'AU',
  Austria = 'AT',
  Azerbaijan = 'AZ',
  Bahamas = 'BS',
  Bahrain = 'BH',
  Bangladesh = 'BD',
  Barbados = 'BB',
  Belarus = 'BY',
  Belgium = 'BE',
  Belize = 'BZ',
  Benin = 'BJ',
  Bermuda = 'BM',
  Bhutan = 'BT',
  Bolivia = 'BO',
  BosniaAndHerzegovina = 'BA',
  Botswana = 'BW',
  BouvetIsland = 'BV',
  Brazil = 'BR',
  BritishIndianOceanTerritory = 'IO',
  BruneiDarussalam = 'BN',
  Bulgaria = 'BG',
  BurkinaFaso = 'BF',
  Burundi = 'BI',
  Cambodia = 'KH',
  Cameroon = 'CM',
  Canada = 'CA',
  CapeVerde = 'CV',
  CaymanIslands = 'KY',
  CentralAfricanRepublic = 'CF',
  Chad = 'TD',
  Chile = 'CL',
  China = 'CN',
  ChristmasIsland = 'CX',
  CocosKeelingIslands = 'CC',
  Colombia = 'CO',
  Comoros = 'KM',
  Congo = 'CG',
  CongoDemocraticRepublic = 'CD',
  CookIslands = 'CK',
  CostaRica = 'CR',
  CoteDIvoire = 'CI',
  Croatia = 'HR',
  Cuba = 'CU',
  Cyprus = 'CY',
  CzechRepublic = 'CZ',
  Denmark = 'DK',
  Djibouti = 'DJ',
  Dominica = 'DM',
  DominicanRepublic = 'DO',
  Ecuador = 'EC',
  Egypt = 'EG',
  ElSalvador = 'SV',
  EquatorialGuinea = 'GQ',
  Eritrea = 'ER',
  Estonia = 'EE',
  Ethiopia = 'ET',
  FalklandIslands = 'FK',
  FaroeIslands = 'FO',
  Fiji = 'FJ',
  Finland = 'FI',
  France = 'FR',
  FrenchGuiana = 'GF',
  FrenchPolynesia = 'PF',
  FrenchSouthernTerritories = 'TF',
  Gabon = 'GA',
  Gambia = 'GM',
  Georgia = 'GE',
  Germany = 'DE',
  Ghana = 'GH',
  Gibraltar = 'GI',
  Greece = 'GR',
  Greenland = 'GL',
  Grenada = 'GD',
  Guadeloupe = 'GP',
  Guam = 'GU',
  Guatemala = 'GT',
  Guernsey = 'GG',
  Guinea = 'GN',
  GuineaBissau = 'GW',
  Guyana = 'GY',
  Haiti = 'HT',
  HeardIslandMcdonaldIslands = 'HM',
  HolySeeVaticanCityState = 'VA',
  Honduras = 'HN',
  HongKong = 'HK',
  Hungary = 'HU',
  Iceland = 'IS',
  India = 'IN',
  Indonesia = 'ID',
  Iran = 'IR',
  Iraq = 'IQ',
  Ireland = 'IE',
  IsleOfMan = 'IM',
  Israel = 'IL',
  Italy = 'IT',
  Jamaica = 'JM',
  Japan = 'JP',
  Jersey = 'JE',
  Jordan = 'JO',
  Kazakhstan = 'KZ',
  Kenya = 'KE',
  Kiribati = 'KI',
  Korea = 'KR',
  Kuwait = 'KW',
  Kyrgyzstan = 'KG',
  LaoPeoplesDemocraticRepublic = 'LA',
  Latvia = 'LV',
  Lebanon = 'LB',
  Lesotho = 'LS',
  Liberia = 'LR',
  LibyanArabJamahiriya = 'LY',
  Liechtenstein = 'LI',
  Lithuania = 'LT',
  Luxembourg = 'LU',
  Macao = 'MO',
  Macedonia = 'MK',
  Madagascar = 'MG',
  Malawi = 'MW',
  Malaysia = 'MY',
  Maldives = 'MV',
  Mali = 'ML',
  Malta = 'MT',
  MarshallIslands = 'MH',
  Martinique = 'MQ',
  Mauritania = 'MR',
  Mauritius = 'MU',
  Mayotte = 'YT',
  Mexico = 'MX',
  Micronesia = 'FM',
  Moldova = 'MD',
  Monaco = 'MC',
  Mongolia = 'MN',
  Montenegro = 'ME',
  Montserrat = 'MS',
  Morocco = 'MA',
  Mozambique = 'MZ',
  Myanmar = 'MM',
  Namibia = 'NA',
  Nauru = 'NR',
  Nepal = 'NP',
  Netherlands = 'NL',
  NetherlandsAntilles = 'AN',
  NewCaledonia = 'NC',
  NewZealand = 'NZ',
  Nicaragua = 'NI',
  Niger = 'NE',
  Nigeria = 'NG',
  Niue = 'NU',
  NorfolkIsland = 'NF',
  NorthernMarianaIslands = 'MP',
  Norway = 'NO',
  Oman = 'OM',
  Pakistan = 'PK',
  Palau = 'PW',
  PalestinianTerritory = 'PS',
  Panama = 'PA',
  PapuaNewGuinea = 'PG',
  Paraguay = 'PY',
  Peru = 'PE',
  Philippines = 'PH',
  Pitcairn = 'PN',
  Poland = 'PL',
  Portugal = 'PT',
  PuertoRico = 'PR',
  Qatar = 'QA',
  Reunion = 'RE',
  Romania = 'RO',
  RussianFederation = 'RU',
  Rwanda = 'RW',
  SaintBarthelemy = 'BL',
  SaintHelena = 'SH',
  SaintKittsAndNevis = 'KN',
  SaintLucia = 'LC',
  SaintMartin = 'MF',
  SaintPierreAndMiquelon = 'PM',
  SaintVincentAndGrenadines = 'VC',
  Samoa = 'WS',
  SanMarino = 'SM',
  SaoTomeAndPrincipe = 'ST',
  SaudiArabia = 'SA',
  Senegal = 'SN',
  Serbia = 'RS',
  Seychelles = 'SC',
  SierraLeone = 'SL',
  Singapore = 'SG',
  Slovakia = 'SK',
  Slovenia = 'SI',
  SolomonIslands = 'SB',
  Somalia = 'SO',
  SouthAfrica = 'ZA',
  SouthGeorgiaAndSandwichIsl = 'GS',
  Spain = 'ES',
  SriLanka = 'LK',
  Sudan = 'SD',
  Suriname = 'SR',
  SvalbardAndJanMayen = 'SJ',
  Swaziland = 'SZ',
  Sweden = 'SE',
  Switzerland = 'CH',
  SyrianArabRepublic = 'SY',
  Taiwan = 'TW',
  Tajikistan = 'TJ',
  Tanzania = 'TZ',
  Thailand = 'TH',
  TimorLeste = 'TL',
  Togo = 'TG',
  Tokelau = 'TK',
  Tonga = 'TO',
  TrinidadAndTobago = 'TT',
  Tunisia = 'TN',
  Turkey = 'TR',
  Turkmenistan = 'TM',
  TurksAndCaicosIslands = 'TC',
  Tuvalu = 'TV',
  Uganda = 'UG',
  Ukraine = 'UA',
  UnitedArabEmirates = 'AE',
  UnitedKingdom = 'GB',
  UnitedStates = 'US',
  UnitedStatesOutlyingIslands = 'UM',
  Uruguay = 'UY',
  Uzbekistan = 'UZ',
  Vanuatu = 'VU',
  Venezuela = 'VE',
  VietNam = 'VN',
  VirginIslandsBritish = 'VG',
  VirginIslandsUS = 'VI',
  WallisAndFutuna = 'WF',
  WesternSahara = 'EH',
  Yemen = 'YE',
  Zambia = 'ZM',
  Zimbabw = 'ZW',
}

export const CountryCodesVue = [] as Array<{text: string; value: string}>;
let index = 0;
const values = Object.values(CountryCodes);
for (let member in CountryCodes) {
  if (member) {
    const value = values[index++];
    if (member === 'Germany') {
      member = 'Deutschland';
    }
    CountryCodesVue.push({
      text: `${member} (${value})`,
      value: value as any,
    });
  }
}

export namespace CountryCodes {
  type Data = { text: string };
  
  export const Record: Record<CountryCodes, Data> = {
    
    [CountryCodes.France]: { text: 'Frankreich' },
    [CountryCodes.Germany]: { text: 'Deutschland' },
    [CountryCodes.Switzerland]: { text: 'Schweiz' },
    [CountryCodes.Poland]: { text: 'Polen' },
    [CountryCodes.Afghanistan]: {text: 'Afghanistan'},
    [CountryCodes.AlandIslands]: {text: 'Ålandinseln'},
    [CountryCodes.Albania]: {text: 'Albanien'},
    [CountryCodes.Algeria]: {text: 'Algerien'},
    [CountryCodes.AmericanSamoa]: {text: 'Amerikanisch-Samoa'},
    [CountryCodes.Andorra]: {text: 'Andorra'},
    [CountryCodes.Angola]: {text: 'Angola'},
    [CountryCodes.Anguilla]: {text: 'Anguilla'},
    [CountryCodes.Antarctica]: {text: 'Antarktis'},
    [CountryCodes.AntiguaAndBarbuda]: {text: 'Antigua und Barbuda'},
    [CountryCodes.Argentina]: {text: 'Argentinien'},
    [CountryCodes.Armenia]: {text: 'Armenien'},
    [CountryCodes.Aruba]: {text: 'Aruba'},
    [CountryCodes.Australia]: {text: 'Australien'},
    [CountryCodes.Austria]: {text: 'Österreich'},
    [CountryCodes.Azerbaijan]: {text: 'Aserbaidschan'},
    [CountryCodes.Bahamas]: {text: 'Bahamas'},
    [CountryCodes.Bahrain]: {text: 'Bahrain'},
    [CountryCodes.Bangladesh]: {text: 'Bangladesch'},
    [CountryCodes.Barbados]: {text: 'Barbados'},
    [CountryCodes.Belarus]: {text: 'Belarus'},
    [CountryCodes.Belgium]: {text: 'Belgien'},
    [CountryCodes.Belize]: {text: 'Belize'},
    [CountryCodes.Benin]: {text: 'Benin'},
    [CountryCodes.Bermuda]: {text: 'Bermuda'},
    [CountryCodes.Bhutan]: {text: 'Bhutan'},
    [CountryCodes.Bolivia]: {text: 'Bolivien'},
    [CountryCodes.BosniaAndHerzegovina]: {text: 'Bosnien und Herzegowina'},
    [CountryCodes.Botswana]: {text: 'Botswana'},
    [CountryCodes.BouvetIsland]: {text: 'Bouvetinsel'},
    [CountryCodes.Brazil]: {text: 'Brasilien'},
    [CountryCodes.BritishIndianOceanTerritory]: {text: 'Britisches Territorium im Indischen Ozean'},
    [CountryCodes.BruneiDarussalam]: {text: 'Brunei'},
    [CountryCodes.Bulgaria]: {text: 'Bulgarien'},
    [CountryCodes.BurkinaFaso]: {text: 'Burkina Faso'},
    [CountryCodes.Burundi]: {text: 'Burundi'},
    [CountryCodes.Cambodia]: {text: 'Kambodscha'},
    [CountryCodes.Cameroon]: {text: 'Kamerun'},
    [CountryCodes.Canada]: {text: 'Kanada'},
    [CountryCodes.CapeVerde]: {text: 'Kap Verde'},
    [CountryCodes.CaymanIslands]: {text: 'Kaimaninseln'},
    [CountryCodes.CentralAfricanRepublic]: {text: 'Zentralafrikanische Republik'},
    [CountryCodes.Chad]: {text: 'Tschad'},
    [CountryCodes.Chile]: {text: 'Chile'},
    [CountryCodes.China]: {text: 'China'},
    [CountryCodes.ChristmasIsland]: {text: 'Weihnachtsinsel'},
    [CountryCodes.CocosKeelingIslands]: {text: 'Kokosinseln'},
    [CountryCodes.Colombia]: {text: 'Kolumbien'},
    [CountryCodes.Comoros]: {text: 'Komoren'},
    [CountryCodes.Congo]: {text: 'Kongo'},
    [CountryCodes.CongoDemocraticRepublic]: {text: 'Demokratische Republik Kongo'},
    [CountryCodes.CookIslands]: {text: 'Cookinseln'},
    [CountryCodes.CostaRica]: {text: 'Costa Rica'},
    [CountryCodes.CoteDIvoire]: {text: 'Elfenbeinküste'},
    [CountryCodes.Croatia]: {text: 'Kroatien'},
    [CountryCodes.Cuba]: {text: 'Kuba'},
    [CountryCodes.Cyprus]: {text: 'Zypern'},
    [CountryCodes.CzechRepublic]: {text: 'Tschechische Republik'},
    [CountryCodes.Denmark]: {text: 'Dänemark'},
    [CountryCodes.Djibouti]: {text: 'Dschibuti'},
    [CountryCodes.Dominica]: {text: 'Dominica'},
    [CountryCodes.DominicanRepublic]: {text: 'Dominikanische Republik'},
    [CountryCodes.Ecuador]: {text: 'Ecuador'},
    [CountryCodes.Egypt]: {text: 'Ägypten'},
    [CountryCodes.ElSalvador]: {text: 'El Salvador'},
    [CountryCodes.EquatorialGuinea]: {text: 'Äquatorialguinea'},
    [CountryCodes.Eritrea]: {text: 'Eritrea'},
    [CountryCodes.Estonia]: {text: 'Estland'},
    [CountryCodes.Ethiopia]: {text: 'Äthiopien'},
    [CountryCodes.FalklandIslands]: {text: 'Falklandinseln'},
    [CountryCodes.FaroeIslands]: {text: 'Färöer'},
    [CountryCodes.Fiji]: {text: 'Fidschi'},
    [CountryCodes.Finland]: {text: 'Finnland'},
    [CountryCodes.FrenchGuiana]: {text: 'Französisch-Guayana'},
    [CountryCodes.FrenchPolynesia]: {text: 'Französisch-Polynesien'},
    [CountryCodes.FrenchSouthernTerritories]: {text: 'Französische Süd- und Antarktisgebiete'},
    [CountryCodes.Gabon]: {text: 'Gabun'},
    [CountryCodes.Gambia]: {text: 'Gambia'},
    [CountryCodes.Georgia]: {text: 'Georgien'},
    [CountryCodes.Ghana]: {text: 'Ghana'},
    [CountryCodes.Gibraltar]: {text: 'Gibraltar'},
    [CountryCodes.Greece]: {text: 'Griechenland'},
    [CountryCodes.Greenland]: {text: 'Grönland'},
    [CountryCodes.Grenada]: {text: 'Grenada'},
    [CountryCodes.Guadeloupe]: {text: 'Guadeloupe'},
    [CountryCodes.Guam]: {text: 'Guam'},
    [CountryCodes.Guatemala]: {text: 'Guatemala'},
    [CountryCodes.Guernsey]: {text: 'Guernsey'},
    [CountryCodes.Guinea]: {text: 'Guinea'},
    [CountryCodes.GuineaBissau]: {text: 'Guinea-Bissau'},
    [CountryCodes.Guyana]: {text: 'Guyana'},
    [CountryCodes.Haiti]: {text: 'Haiti'},
    [CountryCodes.HeardIslandMcdonaldIslands]: {text: 'Heard und McDonaldinseln'},
    [CountryCodes.HolySeeVaticanCityState]: {text: 'Vatikanstadt'},
    [CountryCodes.Honduras]: {text: 'Honduras'},
    [CountryCodes.HongKong]: {text: 'Hongkong'},
    [CountryCodes.Hungary]: {text: 'Ungarn'},
    [CountryCodes.Iceland]: {text: 'Island'},
    [CountryCodes.India]: {text: 'Indien'},
    [CountryCodes.Indonesia]: {text: 'Indonesien'},
    [CountryCodes.Iran]: {text: 'Iran'},
    [CountryCodes.Iraq]: {text: 'Irak'},
    [CountryCodes.Ireland]: {text: 'Irland'},
    [CountryCodes.IsleOfMan]: {text: 'Isle of Man'},
    [CountryCodes.Israel]: {text: 'Israel'},
    [CountryCodes.Italy]: {text: 'Italien'},
    [CountryCodes.Jamaica]: {text: 'Jamaika'},
    [CountryCodes.Japan]: {text: 'Japan'},
    [CountryCodes.Jersey]: {text: 'Jersey'},
    [CountryCodes.Jordan]: {text: 'Jordanien'},
    [CountryCodes.Kazakhstan]: {text: 'Kasachstan'},
    [CountryCodes.Kenya]: {text: 'Kenia'},
    [CountryCodes.Kiribati]: {text: 'Kiribati'},
    [CountryCodes.Korea]: {text: 'Korea'},
    [CountryCodes.Kuwait]: {text: 'Kuwait'},
    [CountryCodes.Kyrgyzstan]: {text: 'Kirgisistan'},
    [CountryCodes.LaoPeoplesDemocraticRepublic]: {text: 'Laos'},
    [CountryCodes.Latvia]: {text: 'Lettland'},
    [CountryCodes.Lebanon]: {text: 'Libanon'},
    [CountryCodes.Lesotho]: {text: 'Lesotho'},
    [CountryCodes.Liberia]: {text: 'Liberia'},
    [CountryCodes.LibyanArabJamahiriya]: {text: 'Libyen'},
    [CountryCodes.Liechtenstein]: {text: 'Liechtenstein'},
    [CountryCodes.Lithuania]: {text: 'Litauen'},
    [CountryCodes.Luxembourg]: {text: 'Luxemburg'},
    [CountryCodes.Macao]: {text: 'Macau'},
    [CountryCodes.Macedonia]: {text: 'Nordmazedonien'},
    [CountryCodes.Madagascar]: {text: 'Madagaskar'},
    [CountryCodes.Malawi]: {text: 'Malawi'},
    [CountryCodes.Malaysia]: {text: 'Malaysia'},
    [CountryCodes.Maldives]: {text: 'Malediven'},
    [CountryCodes.Mali]: {text: 'Mali'},
    [CountryCodes.Malta]: {text: 'Malta'},
    [CountryCodes.MarshallIslands]: {text: 'Marshallinseln'},
    [CountryCodes.Martinique]: {text: 'Martinique'},
    [CountryCodes.Mauritania]: {text: 'Mauretanien'},
    [CountryCodes.Mauritius]: {text: 'Mauritius'},
    [CountryCodes.Mayotte]: {text: 'Mayotte'},
    [CountryCodes.Mexico]: {text: 'Mexiko'},
    [CountryCodes.Micronesia]: {text: 'Mikronesien'},
    [CountryCodes.Moldova]: {text: 'Moldawien'},
    [CountryCodes.Monaco]: {text: 'Monaco'},
    [CountryCodes.Mongolia]: {text: 'Mongolei'},
    [CountryCodes.Montenegro]: {text: 'Montenegro'},
    [CountryCodes.Montserrat]: {text: 'Montserrat'},
    [CountryCodes.Morocco]: {text: 'Marokko'},
    [CountryCodes.Mozambique]: {text: 'Mosambik'},
    [CountryCodes.Myanmar]: {text: 'Myanmar'},
    [CountryCodes.Namibia]: {text: 'Namibia'},
    [CountryCodes.Nauru]: {text: 'Nauru'},
    [CountryCodes.Nepal]: {text: 'Nepal'},
    [CountryCodes.Netherlands]: {text: 'Niederlande'},
    [CountryCodes.NetherlandsAntilles]: {text: 'Niederländische Antillen'},
    [CountryCodes.NewCaledonia]: {text: 'Neukaledonien'},
    [CountryCodes.NewZealand]: {text: 'Neuseeland'},
    [CountryCodes.Nicaragua]: {text: 'Nicaragua'},
    [CountryCodes.Niger]: {text: 'Niger'},
    [CountryCodes.Nigeria]: {text: 'Nigeria'},
    [CountryCodes.Niue]: {text: 'Niue'},
    [CountryCodes.NorfolkIsland]: {text: 'Norfolkinsel'},
    [CountryCodes.NorthernMarianaIslands]: {text: 'Nördliche Marianen'},
    [CountryCodes.Norway]: {text: 'Norwegen'},
    [CountryCodes.Oman]: {text: 'Oman'},
    [CountryCodes.Pakistan]: {text: 'Pakistan'},
    [CountryCodes.Palau]: {text: 'Palau'},
    [CountryCodes.PalestinianTerritory]: {text: 'Palästinensische Gebiete'},
    [CountryCodes.Panama]: {text: 'Panama'},
    [CountryCodes.PapuaNewGuinea]: {text: 'Papua-Neuguinea'},
    [CountryCodes.Paraguay]: {text: 'Paraguay'},
    [CountryCodes.Peru]: {text: 'Peru'},
    [CountryCodes.Philippines]: {text: 'Philippinen'},
    [CountryCodes.Pitcairn]: {text: 'Pitcairninseln'},
    [CountryCodes.Portugal]: {text: 'Portugal'},
    [CountryCodes.PuertoRico]: {text: 'Puerto Rico'},
    [CountryCodes.Qatar]: {text: 'Katar'},
    [CountryCodes.Reunion]: {text: 'Reunion'},
    [CountryCodes.Romania]: {text: 'Romania'},
    [CountryCodes.RussianFederation]: {text: 'Russian Federation'},
    [CountryCodes.Rwanda]: {text: 'Rwanda'},
    [CountryCodes.SaintBarthelemy]: {text: 'Saint Barthelemy'},
    [CountryCodes.SaintHelena]: {text: 'Saint Helena'},
    [CountryCodes.SaintKittsAndNevis]: {text: 'Saint Kitts and Nevis'},
    [CountryCodes.SaintLucia]: {text: 'Saint Lucia'},
    [CountryCodes.SaintMartin]: {text: 'Saint Martin'},
    [CountryCodes.SaintPierreAndMiquelon]: {text: 'Saint Pierre and Miquelon'},
    [CountryCodes.SaintVincentAndGrenadines]: {text: 'Saint Vincent and Grenadines'},
    [CountryCodes.Samoa]: {text: 'Samoa'},
    [CountryCodes.SanMarino]: {text: 'San Marino'},
    [CountryCodes.SaoTomeAndPrincipe]: {text: 'Sao Tome and Principe'},
    [CountryCodes.SaudiArabia]: {text: 'Saudi Arabia'},
    [CountryCodes.Senegal]: {text: 'Senegal'},
    [CountryCodes.Serbia]: {text: 'Serbien'},
    [CountryCodes.Seychelles]: {text: 'Seychelles'},
    [CountryCodes.SierraLeone]: {text: 'Sierra Leone'},
    [CountryCodes.Singapore]: {text: 'Singapore'},
    [CountryCodes.Slovakia]: {text: 'Slovakia'},
    [CountryCodes.Slovenia]: {text: 'Slovenia'},
    [CountryCodes.SolomonIslands]: {text: 'Solomon Islands'},
    [CountryCodes.Somalia]: {text: 'Somalia'},
    [CountryCodes.SouthAfrica]: {text: 'South Africa'},
    [CountryCodes.SouthGeorgiaAndSandwichIsl]: {text: 'South Georgia and Sandwich Islands'},
    [CountryCodes.Spain]: {text: 'Spanien'},
    [CountryCodes.SriLanka]: {text: 'Sri Lanka'},
    [CountryCodes.Sudan]: {text: 'Sudan'},
    [CountryCodes.Suriname]: {text: 'Suriname'},
    [CountryCodes.SvalbardAndJanMayen]: {text: 'Svalbard and Jan Mayen'},
    [CountryCodes.Swaziland]: {text: 'Swaziland'},
    [CountryCodes.Sweden]: {text: 'Schweden'},
    [CountryCodes.SyrianArabRepublic]: {text: 'Syrian Arab Republic'},
    [CountryCodes.Taiwan]: {text: 'Taiwan'},
    [CountryCodes.Tajikistan]: {text: 'Tajikistan'},
    [CountryCodes.Tanzania]: {text: 'Tanzania'},
    [CountryCodes.Thailand]: {text: 'Thailand'},
    [CountryCodes.TimorLeste]: {text: 'Timor-Leste'},
    [CountryCodes.Togo]: {text: 'Togo'},
    [CountryCodes.Tokelau]: {text: 'Tokelau'},
    [CountryCodes.Tonga]: {text: 'Tonga'},
    [CountryCodes.TrinidadAndTobago]: {text: 'Trinidad and Tobago'},
    [CountryCodes.Tunisia]: {text: 'Tunisia'},
    [CountryCodes.Turkey]: {text: 'Türkei'},
    [CountryCodes.Turkmenistan]: {text: 'Turkmenistan'},
    [CountryCodes.TurksAndCaicosIslands]: {text: 'Turks and Caicos Islands'},
    [CountryCodes.Tuvalu]: {text: 'Tuvalu'},
    [CountryCodes.Uganda]: {text: 'Uganda'},
    [CountryCodes.Ukraine]: {text: 'Ukraine'},
    [CountryCodes.UnitedArabEmirates]: {text: 'United Arab Emirates'},
    [CountryCodes.UnitedKingdom]: {text: 'United Kingdom'},
    [CountryCodes.UnitedStates]: {text: 'United States'},
    [CountryCodes.UnitedStatesOutlyingIslands]: {text: 'United States Outlying Islands'},
    [CountryCodes.Uruguay]: {text: 'Uruguay'},
    [CountryCodes.Uzbekistan]: {text: 'Uzbekistan'},
    [CountryCodes.Vanuatu]: {text: 'Vanuatu'},
    [CountryCodes.Venezuela]: {text: 'Venezuela'},
    [CountryCodes.VietNam]: {text: 'Vietnam'},
    [CountryCodes.VirginIslandsBritish]: {text: 'Virgin Islands (British)'},
    [CountryCodes.VirginIslandsUS]: {text: 'Virgin Islands (US)'},
    [CountryCodes.WallisAndFutuna]: {text: 'Wallis and Futuna'},
    [CountryCodes.WesternSahara]: {text: 'Western Sahara'},
    [CountryCodes.Yemen]: {text: 'Yemen'},
    [CountryCodes.Zambia]: {text: 'Zambia'},
    [CountryCodes.Zimbabw]: {text: 'Zimbabwe'},
  }

  export const Items = mapRecordToItems(Record);
  Items.sort((a, b) => {
    if (a.value === CountryCodes.Germany) {
      return -1;
    }
    if (b.value === CountryCodes.Germany) {
      return 1;
    }
    return a.text.localeCompare(b.text);
  });
}
